import createIcon from '../../createIcon';

/**
 * @component @name Terrain
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNkwxMC4yNSAxMUwxMy4xIDE0LjhMMTEuNSAxNkM5LjgxIDEzLjc1IDcgMTAgNyAxMEwxIDE4SDIzTDE0IDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Terrain = createIcon('Terrain', [
  [
    'path',
    { d: 'M14 6L10.25 11L13.1 14.8L11.5 16C9.81 13.75 7 10 7 10L1 18H23L14 6Z', key: '1iyc8y' },
  ],
]);

export default Terrain;
